/// <reference types="@types/googlemaps" />
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgForm } from '@angular/forms';
import { FacilitiesService } from '../services/facilities.service';
import { Facility } from 'models/facility.model';
import { AnalysisService } from '../services/analysis.service';
import { PreviousRouteServiceService } from '../services/previous-route-service.service';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { ModalProfileComponent } from '../modal-profile/modal-profile.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
  @ViewChild(ToastContainerDirective) toastContainer: ToastContainerDirective;

  Facility: Facility;
  currentFacilities: any = [];
  facilityImage: any = require("../image/facilities.jpg");
  plusImage: any = require("../image/plus.png");
  logoImage: any = require("../image/logo/Amodto_Trasparent.png");
  markerImage: any = require("../image/logo/locationIcon.png")
  modules: any;
  tags: any;

  roles = []

  lat: any = 41.89332;
  lng: any = 12.482932;
  zoom: number = 10;
  place: string;
  streetNumber: string;
  country: string;

  modalReference: any;
  selectedFile: File;

  facilitiesSelected: { [id: number]: any } = {};
  tagSelected: { [id: number]: any } = {};
  loading: boolean;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private translate: TranslateService,
    private facilitiesService: FacilitiesService,
    private previousRouteService: PreviousRouteServiceService,
    private analysisService: AnalysisService,
    private toastr: ToastrService
  ) { }


  ngOnInit() {
    this.translate.use(localStorage.getItem('localLanguage'));
    this.translate.get('OWNER.TITLE').subscribe((res: string) => {
      this.roles.push({ role: 'FACILITYOWNER', value: res });
    });
    this.translate.get('EMPLOYEE.TITLE').subscribe((res: string) => {
      this.roles.push({ role: 'FACILITYEMPLOYEE', value: res });
    });

    this.resetForm();

    this.getFacilities();

    this.getTags();

    if (navigator) {
      navigator.geolocation.getCurrentPosition(pos => {
        this.lng = +pos.coords.longitude;
        this.lat = +pos.coords.latitude;
        this.zoom = 13;
        this.place = null;
      })
    }

    this.myLocation();

    localStorage.removeItem('localModules');
    localStorage.removeItem('localIDElaboration');
    localStorage.removeItem('localStateAnalysis');
  }

  //Method used to delete elements of LocalStorage.
  LogOut() {
    localStorage.removeItem('localUser');
    localStorage.removeItem('localLanguage');
    localStorage.removeItem('localFacilities');
    localStorage.removeItem('localID');
    localStorage.removeItem('localTags');
    localStorage.removeItem('localSurveyCompiled');
    this.router.navigate(['welcome']);
  }

  //Method used to Save place selected when user change location.
  onChoseLocation(event) {
    this.lat = event.coords.lat
    this.lng = event.coords.lng

    const position = new google.maps.LatLng(this.lat, this.lng);
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({ "location": position }, (result, status) => {

      this.place = result[0].formatted_address;
      let streetNumber: string;

      ///va rivisitato in chiave di paesi esterni che non hanno la terza variabile o hanno comunque una struttura diversa del risultato
      for (let places of result[0].address_components) {

        if (places.types[0] == 'street_number') { streetNumber = places.long_name }
        if (places.types[0] == 'route') { this.Facility.Address = places.long_name + " " + streetNumber }
        if (places.types[0] == 'administrative_area_level_3' || places.types[0] == 'locality') { this.Facility.City = places.long_name }
      }
    })
  }

  //Method used to view user place.
  myLocation() {
    if (navigator) {
      navigator.geolocation.getCurrentPosition(pos => {
        this.lng = +pos.coords.longitude;
        this.lat = +pos.coords.latitude;
        const position = new google.maps.LatLng(this.lat, this.lng);
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({ "location": position }, (result, status) => {
          this.country = result[0].formatted_address;
          let streetNumber: string;
          for (let places of result[0].address_components) {
            if (places.types[0] == 'street_number') { streetNumber = places.long_name }
            if (places.types[0] == 'route') { this.Facility.Address = places.long_name + " " + streetNumber }
            if (places.types[0] == 'administrative_area_level_3') { this.Facility.City = places.long_name }
          }
        })
      })
    }
  }

  geolocation() {
    this.place = this.country;
  }

  // Modal
  openModalProfile() {
    this.modalService.open(ModalProfileComponent, { centered: true });
  }

  openVerticallyCentered(content) {
    this.modalReference = this.modalService.open(content, { centered: true, size: 'lg' });
  }

  close() {
    this.modalReference.close();
  }

  editPlace() {
    this.place = null;
  }

  deleteFile() {
    this.selectedFile = undefined;
    this.Facility.ProfileImageURL = "";
  }

  uploadFile(event) {
    // upload code for photo
    if (event instanceof FileList) this.selectedFile = event[0];
    else this.selectedFile = event.target.files[0];
    this.Facility.ProfileImageURL = this.selectedFile.name;
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key == 'Enter') {
      event.preventDefault();
      return false;
    }
  }

  // Reset Form Register Facilities
  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();
    this.Facility = {
      ID: 0,
      Nome: '',
      Latitudine: '',
      Longitudine: '',
      Address: '',
      City: '',
      VATNumber: '',
      ProfileImageURL: '',
      Facebook: '',
      Twitter: '',
      Forsquare: '',
      GoogleAnalytics: '',
      FacilityRole: '',
      IdTag: 0
    }
  }

  // API Register Facilities
  OnSubmit(form: NgForm) {
    //Call Api of Analisys service used to insert Facility.
    this.analysisService.insertFacilities(form.value)
      .subscribe(
        data => {
          this.resetForm(form);
          this.translate.get('200_STRUCTURE.TITLE').subscribe((res: string) => {
            this.toastr.success(res, null, {
              positionClass: 'toast-top-center',
              timeOut: 2000
            });
          });
          this.modalReference.close();
          this.getFacilities();
        },
        error => {
          if (error.status === 400) {
            this.translate.get('400_STRUCTURE.TITLE').subscribe((res: string) => {
              this.toastr.error(res, null, {
                positionClass: 'toast-top-center',
                timeOut: 2000
              });
            });

          } else if (error.status === 409) {
            this.translate.get('409_STRUCTURE.TITLE').subscribe((res: string) => {
              this.toastr.error(res, null, {
                positionClass: 'toast-top-center',
                timeOut: 2000
              });
            });

          } else if (error.status === 406) {
            this.translate.get('409_STRUCTURE.TITLE').subscribe((res: string) => {
              this.toastr.error(res, null, {
                positionClass: 'toast-top-center',
                timeOut: 2000
              });
            });

          } else {
            this.router.navigate(['/errorPage']);
          }
          throw error;
        });
  }


  // API Return Facilities
  getFacilities() {
    //Call Api of Facilities Service  used to return current facilities.
    this.loading = true;

    this.facilitiesService.getFacilities()
      .subscribe(
        data => {
          this.currentFacilities = data;
          //fill Dictionary with facilities and save ID  and current Facility in Local Storage.
          for (let myFacilities of this.currentFacilities) {
            this.facilitiesSelected[myFacilities.ID] = { myFacilities }
            localStorage.setItem('localID', JSON.stringify(this.facilitiesSelected[myFacilities.ID].myFacilities.ID));
          }
          localStorage.setItem('localFacilities', JSON.stringify(this.facilitiesSelected));

          var localID = localStorage.getItem('localID')
          var itemIDLocal = JSON.parse(localID)

          //console.log(this.previousRouteService.getPreviousUrl());
          //Check CurrentFacilities lenght and previous route service.
          // console.log(this.previousRouteService.getPreviousUrl());
          if (this.currentFacilities.length == 1 && this.facilitiesSelected[itemIDLocal].myFacilities.AnalysisStatus !== 'InAttesaDiAccettazione') {
            switch (this.previousRouteService.getPreviousUrl()) {
              case '/': {
                this.getModules(itemIDLocal);
                break;
              }
              case '/welcome': {
                this.getModules(itemIDLocal);
                break;
              }
              case '/home': {
                this.getModules(itemIDLocal);
                break;
              }
              default: {
                //statements; 
                break;
              }
            }
            this.loading = false;
          } else {
            this.router.navigate(['/home'])
            this.loading = false;
          }
        }, error => {
          this.router.navigate(['/errorPage']);
        });
  }

  //API Return Tags
  getTags() {
    //Call Api of Analysis Service  used to return tags of current facility.
    this.analysisService.getTags()
      .subscribe(
        data => {
          this.tags = data;
          for (let myTag of this.tags) {
            this.tagSelected[myTag.ID] = { Name: myTag.Name };
          }
          localStorage.setItem('localTags', JSON.stringify(this.tagSelected));
        },
        error => {
          this.router.navigate(['/home']);
        });
  }

  // API return modules of Facility
  getModules(facilityId) {
    //Check status of facility selected.
    var status = this.facilitiesSelected[facilityId].myFacilities.AnalysisStatus;
    if (status !== 'InAttesaDiAccettazione' && status !== 'Nessuna analisi in corso') {
      //Call Api of Facility Service  used go to HomeFacility component.
      this.facilitiesService.getModules(facilityId)
        .subscribe(
          data => {
            this.modules = data;
            this.router.navigate(['/homeFacility']);
            localStorage.setItem('localModules', JSON.stringify(this.modules));
            localStorage.setItem('localID', JSON.stringify(facilityId));
          },
          error => {
            this.router.navigate(['/errorPage']);
          });
    } else {
      this.router.navigate(['/home']);
    }
  }
}
